import React from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { RoutePath } from 'enums/Routes';
import { getApplicationData } from 'selectors/getApplicationData';
import { getYourIncomeVariant } from 'selectors/yourIncome';
import useLayoutTheme from 'hooks/useLayoutTheme';
import usePlaidValidateIdentity from 'hooks/usePlaidValidateIdentity';
import Expander from 'components/Expander';
import { useVerificationSteps } from 'components/Verification/verificationSteps';
import { usePartnerData } from 'enums/PartnerName';
import { PlaidAccountError } from 'api/PlaidApi';

import getQuestions, { Question } from './getQuestions';

import styles from './CommonQuestions.module.scss';

const CommonQuestions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { application } = useSelector(getApplicationData);
  const { themeStyles } = useLayoutTheme();
  const { currentStep: verificationStep } = useVerificationSteps();
  const variant = useSelector(getYourIncomeVariant);
  const { directDepositInstructions } = usePartnerData();
  const { plaidAccountError } = usePlaidValidateIdentity({
    applicationId: application?.id,
  });
  const questions = getQuestions(location.pathname as RoutePath, {
    application,
    verificationStep,
    variant,
    navigate,
    employerPortalDataInstructions: application?.employment.employer1.employerPortalData,
    directDepositInstructions: !!directDepositInstructions,
    plaidAccountError: plaidAccountError === PlaidAccountError.ACCOUNT_OWNER_MISMATCH_ERROR,
  });

  if (questions.length === 0) {
    return <></>;
  }

  return (
    <div className={clsx(styles.commonQuestions, themeStyles.commonQuestions)}>
      <h4 className={styles.heading}>Common questions:</h4>
      <div className={clsx(styles.questions, themeStyles.questions)}>
        {questions.map((question: Question) => (
          <Expander
            key={question.question}
            container={styles.expanderContainer}
            label={question.question}
            labelClassname={styles.label}
            content={question.answer}
            selectArrowClassname={clsx(styles.selectArrow, themeStyles.selectArrow)}
            openClassname={styles.expanderOpen}
          />
        ))}
      </div>
    </div>
  );
};

export default CommonQuestions;
